var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShieldIso(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 389,
    height: 733,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.007 0l56.944 37.99c23.596 12.404 39.714 18.98 48.354 19.725 12.959 1.12 36.896-1.972 58.554 13.645 14.438 10.411 27.985 22.949 40.64 37.611 14.737 15.593 28.184 26.423 40.343 32.492 12.158 6.068 31.467 12.4 57.927 18.995 5.676 115.67.522 195.446-15.464 239.328-15.985 43.881-79.394 82.024-159.932 81.2-27.463-32.306-31.562-73.113-42.592-89.194-31.36-45.72-43.505-79.777-54.1-103.317-16.679-37.058-29.61-70.414-29.61-100.005 0-29.198-11.691-85.19-35.071-167.975L59.007 0z",
    fill: "#418CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 22l55.893 40.041c23.603 12.42 39.724 19.004 48.366 19.751 12.962 1.12 36.905-1.975 58.567 13.663 14.442 10.424 27.992 22.978 40.65 37.66 14.74 15.612 28.19 26.457 40.352 32.533 12.161 6.076 31.475 12.416 57.94 19.02 5.678 115.82.522 195.699-15.467 239.637-15.989 43.939-64.261 65.496-144.817 64.672C72.16 417.291 25 325.204 25 212.716V22z",
    fill: "#A8CCFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 79c12.918 16.053 23.183 26.387 30.794 31.002 23.13 14.022 47.222 15.977 51.806 16.373 8.162.705 21.82-.699 35.698 4.916 2.389.966 5.956 2.936 10.702 5.91L168.091 449C93.364 384.858 56 311.895 56 230.11V79z",
    fill: "#418CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.595 274.33c-2.887 2.98-3.365 10.623-1.435 22.93l33.008 67.22 6.646.52 73.442-93.523c6.405-8.156 5.032-19.951-3.075-26.418l-2.05-1.635c-6.477-5.166-15.915-4.104-21.08 2.372a15 15 0 0 0-.639.861l-38.106 55.479-16.708-25.075c-5.926-8.893-17.94-11.299-26.833-5.373a19.35 19.35 0 0 0-3.17 2.641z",
    fill: "#418CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.369 274.415l-.57 1.097a28 28 0 0 0 .584 26.901L161 359l74.197-93.757c6.47-8.176 5.088-20.05-3.088-26.522-7.349-5.817-18.022-4.575-23.84 2.774a16.97 16.97 0 0 0-1.042 1.472l-41.824 66.24-20.925-35.245a9.22 9.22 0 0 0-16.11.453z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.141,
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.815 492.598l365.37 136.032c7.27 2.932 11.815 8.21 11.815 13.486V733L0 588.173v-91.47c0-3.518 6.362-5.864 11.815-4.105z",
    fill: "#FDFDFE",
    opacity: 0.02
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 489.61l365.37 137.028c7.27 2.954 11.815 8.27 11.815 13.585V730L0 584.112v-90.958c0-2.953 6.362-5.316 11.815-3.544z",
    fill: "#FBFCFD",
    opacity: 0.039
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 493.597l365.37 135.756c7.27 2.926 11.815 8.192 11.815 13.459V730L0 586.052v-88.359c0-3.51 6.362-5.851 11.815-4.096z",
    fill: "#F9FAFD",
    opacity: 0.059
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 489.6l365.37 136.43c7.27 2.94 11.815 8.233 11.815 13.525V726L0 580.75v-87.034c0-3.528 6.362-5.88 11.815-4.116z",
    fill: "#F7F8FC",
    opacity: 0.078
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 492.594l365.37 135.133c7.27 2.913 11.815 8.155 11.815 13.397V725L0 581.13v-84.458c0-3.495 6.362-5.825 11.815-4.078z",
    fill: "#F5F6FB",
    opacity: 0.098
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 489.599l365.37 136.154c7.27 2.934 11.815 8.216 11.815 13.498V722L0 577.043v-83.336c0-3.521 6.362-5.869 11.815-4.108z",
    fill: "#F3F5FA",
    opacity: 0.118
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 489.6l365.37 136.603c7.27 2.944 11.815 8.243 11.815 13.542V721L0 575.566v-81.844c0-3.533 6.362-5.888 11.815-4.121z",
    fill: "#F1F3FA",
    opacity: 0.137
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 489.608l365.37 138.358c7.27 2.982 11.815 8.35 11.815 13.717V721L0 573.697v-79.914c0-3.578 6.362-5.964 11.815-4.175z",
    fill: "#EDEFF8",
    opacity: 0.176
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 489.603l365.37 137.029c7.27 2.953 11.815 8.269 11.815 13.584V717L0 571.111v-77.374c0-3.544 6.362-5.906 11.815-4.134z",
    fill: "#EBEEF7",
    opacity: 0.196
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 489.6l365.37 136.285c7.27 2.937 11.815 8.224 11.815 13.51V714L0 568.903v-75.192c0-3.524 6.362-5.874 11.815-4.112z",
    fill: "#E9ECF7",
    opacity: 0.216
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 492.596l365.37 135.53c7.27 2.92 11.815 8.178 11.815 13.436V714L0 569.708v-73.023c0-3.505 6.362-5.842 11.815-4.089z",
    fill: "#E7EAF6",
    opacity: 0.235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 489.6l365.37 136.609c7.27 2.944 11.815 8.243 11.815 13.543V711L0 565.56v-71.837c0-3.533 6.362-5.889 11.815-4.122z",
    fill: "#E5E9F5",
    opacity: 0.255
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 489.613l365.37 137.7c7.27 2.967 11.815 8.309 11.815 13.65V711L0 564.398v-71.223c0-2.968 6.362-5.342 11.815-3.562z",
    fill: "#E3E7F4",
    opacity: 0.275
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 489.609l365.37 138.444c7.27 2.984 11.815 8.354 11.815 13.725V711L0 563.605v-69.819c0-3.58 6.362-5.967 11.815-4.177z",
    fill: "#E1E5F4",
    opacity: 0.294
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 489.597l365.37 135.798c7.27 2.926 11.815 8.194 11.815 13.462V705L0 560.423v-66.729c0-3.512 6.362-5.853 11.815-4.097z",
    fill: "#DFE3F3",
    opacity: 0.314
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 489.596l365.37 135.643c7.27 2.924 11.815 8.186 11.815 13.448V703L0 558.587V493.69c0-3.508 6.362-5.847 11.815-4.093z",
    fill: "#DDE2F2",
    opacity: 0.333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 489.601l365.37 136.764c7.27 2.948 11.815 8.253 11.815 13.559V703L0 557.394v-63.666c0-3.537 6.362-5.895 11.815-4.127z",
    fill: "#DBE0F1",
    opacity: 0.353
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 489.598l365.37 135.97c7.27 2.93 11.815 8.205 11.815 13.48V700L0 555.239V493.7c0-3.516 6.362-5.86 11.815-4.102z",
    fill: "#D9DEF0",
    opacity: 0.372
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 489.61l365.37 137.108c7.27 2.955 11.815 8.274 11.815 13.593V700L0 554.028v-60.871c0-2.955 6.362-5.32 11.815-3.546z",
    fill: "#D7DCF0",
    opacity: 0.392
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 489.603l365.37 137.232c7.27 2.958 11.815 8.281 11.815 13.605V699L0 552.896v-59.152c0-3.549 6.362-5.915 11.815-4.14z",
    fill: "#D5DBEF",
    opacity: 0.412
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 489.609l365.37 138.4c7.27 2.984 11.815 8.353 11.815 13.722V699L0 551.65v-57.866c0-3.579 6.362-5.965 11.815-4.175z",
    fill: "#D3D9EE",
    opacity: 0.431
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 489.602l365.37 136.932c7.27 2.951 11.815 8.263 11.815 13.575V695L0 549.215v-55.481c0-3.542 6.362-5.903 11.815-4.132z",
    fill: "#D1D7ED",
    opacity: 0.451
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 489.593l365.37 134.766c7.27 2.905 11.815 8.133 11.815 13.36V690L0 546.52v-52.861c0-3.485 6.362-5.81 11.815-4.066z",
    fill: "#CFD6ED",
    opacity: 0.471
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 489.598l365.37 135.945c7.27 2.93 11.815 8.204 11.815 13.477V690L0 545.265V493.7c0-3.516 6.362-5.86 11.815-4.102z",
    fill: "#CDD4EC",
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 489.61l365.37 137.14c7.27 2.956 11.815 8.276 11.815 13.596V690L0 543.994v-50.836c0-2.956 6.362-5.32 11.815-3.547z",
    fill: "#CBD2EB",
    opacity: 0.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 493.595l365.37 135.21c7.27 2.914 11.815 8.16 11.815 13.405V690L0 546.047v-48.373c0-3.497 6.362-5.828 11.815-4.08z",
    fill: "#C9D0EA",
    opacity: 0.529
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 489.6l365.37 136.422c7.27 2.94 11.815 8.232 11.815 13.524V686L0 540.758v-47.042c0-3.528 6.362-5.88 11.815-4.116z",
    fill: "#C7CFEA",
    opacity: 0.549
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 489.596l365.37 135.558c7.27 2.922 11.815 8.18 11.815 13.44V683L0 538.677v-44.99c0-3.507 6.362-5.844 11.815-4.09z",
    fill: "#C5CDE9",
    opacity: 0.569
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 492.595l365.37 135.384c7.27 2.918 11.815 8.17 11.815 13.422V684L0 539.863V496.68c0-3.501 6.362-5.835 11.815-4.085z",
    fill: "#C3CBE8",
    opacity: 0.588
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 489.6l365.37 136.63c7.27 2.945 11.815 8.245 11.815 13.546V681L0 535.537v-41.814c0-3.533 6.362-5.889 11.815-4.122z",
    fill: "#C1CAE7",
    opacity: 0.608
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 489.614l365.37 137.893c7.27 2.972 11.815 8.321 11.815 13.67V681L0 534.192V493.18c0-2.971 6.362-5.349 11.815-3.566z",
    fill: "#BFC8E7",
    opacity: 0.627
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 489.6l365.37 136.59c7.27 2.944 11.815 8.243 11.815 13.541V678L0 532.58v-38.858c0-3.533 6.362-5.888 11.815-4.121z",
    fill: "#BDC6E6",
    opacity: 0.647
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 489.606l365.37 137.878c7.27 2.972 11.815 8.32 11.815 13.67V678L0 531.207v-37.44c0-3.566 6.362-5.944 11.815-4.16z",
    fill: "#BBC4E5",
    opacity: 0.667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 489.6l365.37 136.244c7.27 2.937 11.815 8.222 11.815 13.507V674L0 528.946V493.71c0-3.524 6.362-5.873 11.815-4.11z",
    fill: "#B9C3E4",
    opacity: 0.686
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 489.595l365.37 135.325c7.27 2.916 11.815 8.166 11.815 13.415V671L0 526.926v-33.248c0-3.5 6.362-5.833 11.815-4.083z",
    fill: "#B7C1E3",
    opacity: 0.706
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 492.609l365.37 136.632c7.27 2.945 11.815 8.245 11.815 13.546V674L0 528.534v-32.392c0-2.944 6.362-5.3 11.815-3.533z",
    fill: "#B5BFE3",
    opacity: 0.726
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 489.615l365.37 137.971c7.27 2.974 11.815 8.326 11.815 13.679V671L0 524.108v-30.925c0-2.974 6.362-5.353 11.815-3.568z",
    fill: "#B3BDE2",
    opacity: 0.745
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 492.6l365.37 136.597c7.27 2.944 11.815 8.243 11.815 13.542V671L0 525.572v-28.85c0-3.533 6.362-5.888 11.815-4.121z",
    fill: "#B1BCE1",
    opacity: 0.765
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 489.607l365.37 137.957c7.27 2.973 11.815 8.325 11.815 13.677V668L0 521.123v-27.354c0-3.568 6.362-5.946 11.815-4.162z",
    fill: "#AFBAE0",
    opacity: 0.784
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 489.6l365.37 136.231c7.27 2.936 11.815 8.221 11.815 13.506V664L0 518.96v-25.25c0-3.524 6.362-5.873 11.815-4.11z",
    fill: "#ADB8E0",
    opacity: 0.804
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 492.598l365.37 136.045c7.27 2.932 11.815 8.21 11.815 13.487V665L0 520.16v-23.457c0-3.518 6.362-5.864 11.815-4.105z",
    fill: "#ABB7DF",
    opacity: 0.824
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 489.612l365.37 137.437c7.27 2.962 11.815 8.293 11.815 13.625V662L0 515.678v-22.511c0-2.962 6.362-5.332 11.815-3.555z",
    fill: "#A9B5DE",
    opacity: 0.843
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 489.619l365.37 138.862c7.27 2.993 11.815 8.38 11.815 13.767V662L0 514.159v-20.95c0-2.992 6.362-5.386 11.815-3.59z",
    fill: "#A7B3DD",
    opacity: 0.863
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 489.6l365.37 136.604c7.27 2.944 11.815 8.244 11.815 13.543V658L0 512.564v-18.842c0-3.532 6.362-5.888 11.815-4.121z",
    fill: "#A5B1DD",
    opacity: 0.882
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 492.596l365.37 135.596c7.27 2.923 11.815 8.183 11.815 13.443V658L0 513.637v-16.95c0-3.506 6.362-5.844 11.815-4.09z",
    fill: "#A3B0DC",
    opacity: 0.902
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 489.603l365.37 137.043c7.27 2.954 11.815 8.27 11.815 13.586V655L0 509.096v-15.358c0-3.545 6.362-5.907 11.815-4.135z",
    fill: "#A1AEDB",
    opacity: 0.922
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 489.598l365.37 136.019c7.27 2.931 11.815 8.208 11.815 13.485V652L0 507.187v-13.485c0-3.518 6.362-5.863 11.815-4.104z",
    fill: "#9FACDA",
    opacity: 0.941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 492.605l365.37 137.502c7.27 2.964 11.815 8.298 11.815 13.632V655L0 509.2v-12.447c0-3.556 6.362-5.926 11.815-4.148z",
    fill: "#9DAADA",
    opacity: 0.961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 489.61l365.37 138.509c7.27 2.985 11.815 8.358 11.815 13.732V652L0 504.535v-10.747c0-3.582 6.362-5.97 11.815-4.179z",
    fill: "#9BA9D9",
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 489.605l365.37 137.47c7.27 2.963 11.815 8.296 11.815 13.63V649L0 502.64v-8.888c0-3.555 6.362-5.925 11.815-4.147z",
    fill: "#99A7D8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldIso);
export default __webpack_public_path__ + "static/media/shield_iso.36244eac642d4689c801ccfd09d6b270.svg";
export { ForwardRef as ReactComponent };